export default __webpack_public_path__ + "static/media/Plant Life Cycle.cdacdd31.png";